import { useState, useEffect, useCallback } from 'react';

const applyDarkMode = (isDark) => {
  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

const useTheme = () => {
  // index.html applies the class before first paint; mirror it to avoid a flash
  const [darkMode, setDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    let isDarkMode;

    if (savedTheme !== null) {
      isDarkMode = savedTheme === 'true';
    } else {
      isDarkMode = !window.matchMedia('(prefers-color-scheme: light)').matches;
    }

    setDarkMode(isDarkMode);
    applyDarkMode(isDarkMode);
  }, []);

  const toggleDarkMode = useCallback(() => {
    setDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem('darkMode', next.toString());
      applyDarkMode(next);
      return next;
    });
  }, []);

  return { darkMode, toggleDarkMode };
};

export default useTheme;
